import React from 'react'

export const BulbIcon: React.FC = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='25.99'
			height='27.09'
			className='bulb-icon-svg'
			viewBox='0 0 25.993 27.085'>
			<g id='light-bulb' transform='translate(-9.8)'>
				<path
					id='XMLID_49_'
					d='M25.884,23.669v.791A1.255,1.255,0,0,1,24.819,25.7l-.2.719a.9.9,0,0,1-.864.663H21.827a.9.9,0,0,1-.864-.663l-.189-.719a1.261,1.261,0,0,1-1.07-1.248v-.791a.761.761,0,0,1,.764-.764H25.12A.769.769,0,0,1,25.884,23.669ZM29.467,13a6.639,6.639,0,0,1-1.873,4.631,6.119,6.119,0,0,0-1.638,3.322,1.1,1.1,0,0,1-1.092.931H20.723a1.093,1.093,0,0,1-1.087-.925,6.187,6.187,0,0,0-1.65-3.333A6.672,6.672,0,1,1,29.467,13Zm-5.919-4.04a.753.753,0,0,0-.752-.752,4.82,4.82,0,0,0-4.815,4.815.752.752,0,1,0,1.5,0,3.314,3.314,0,0,1,3.31-3.31A.749.749,0,0,0,23.549,8.961ZM22.8,4.141a.753.753,0,0,0,.752-.752V.752a.752.752,0,1,0-1.5,0V3.388A.753.753,0,0,0,22.8,4.141ZM13.941,13a.753.753,0,0,0-.752-.752H10.552a.752.752,0,0,0,0,1.5h2.636A.749.749,0,0,0,13.941,13Zm21.1-.752H32.4a.752.752,0,1,0,0,1.5H35.04a.752.752,0,1,0,0-1.5ZM15.473,19.26l-1.867,1.867a.751.751,0,0,0,1.059,1.064l1.867-1.867a.751.751,0,1,0-1.059-1.064ZM29.59,6.955a.751.751,0,0,0,.529-.217l1.867-1.867a.753.753,0,1,0-1.064-1.064L29.055,5.673a.75.75,0,0,0,0,1.064A.764.764,0,0,0,29.59,6.955ZM15.473,6.732a.751.751,0,1,0,1.059-1.064L14.665,3.8A.753.753,0,0,0,13.6,4.865ZM30.119,19.26a.753.753,0,1,0-1.064,1.064l1.867,1.867a.751.751,0,0,0,1.059-1.064Z'
					transform='translate(0)'
					fill='#3b2a82'
				/>
			</g>
		</svg>
	)
}
